import { render, staticRenderFns } from "./EditRequestRatioModal.vue?vue&type=template&id=099f9056&scoped=true&"
import script from "./EditRequestRatioModal.vue?vue&type=script&lang=js&"
export * from "./EditRequestRatioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f9056",
  null
  
)

export default component.exports